import { unitPriceIncTax } from '@fieldops/shared'

/*
 * Dollars as people type them, and back. Money is integer minor units
 * everywhere past the text box (rule 2); these are the only places a typed
 * string becomes cents. `toMinorUnits` / `dollarsInput` in `format.ts` are
 * the strict pair for a rate that cannot be negative.
 */

/** Dollars as typed to integer minor units. Null for blank or not a number. */
export function centsOf(text: string): number | null {
  const trimmed = text.trim().replace(/[$,\s]/g, '')
  if (trimmed === '') return null
  const value = Number(trimmed)
  return Number.isFinite(value) ? Math.round(value * 100) : null
}

/** The same, for a row being typed into, where blank or half-typed counts as nothing. */
export function centsOrZero(text: string): number {
  return centsOf(text) ?? 0
}

/** Cents as a person would type them: "245", "245.50". Blank for null. */
export function dollarsOf(cents: number | null): string {
  if (cents === null) return ''
  return (cents / 100).toFixed(2).replace(/\.00$/, '')
}

/**
 * The ex-tax unit price for a price typed inc GST. Of the cents either side of
 * the plain division it takes one that `unitPriceIncTax` turns back into
 * exactly what was typed, so $245.00 does not come back as $244.99.
 */
export function exTaxFromIncTax(incTax: number, taxRateBasisPoints: number): number {
  const guess = Math.round((incTax * 10_000) / (10_000 + taxRateBasisPoints))
  return (
    [guess, guess - 1, guess + 1].find(
      (unitPrice) => unitPriceIncTax({ unitPrice, taxRateBasisPoints }) === incTax,
    ) ?? guess
  )
}
